import { Component, OnInit } from '@angular/core';
import { Location } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-show-vimeo',
  templateUrl: './show-vimeo.component.html',
  styleUrls: ['./show-vimeo.component.scss'],
})
export class ShowVimeoComponent implements OnInit {
  link: string;
  constructor(
    private _location: Location,
    private activatedRoute: ActivatedRoute
  ) {
    this.link =
      'https://player.vimeo.com/video/' +
      this.activatedRoute.snapshot.paramMap.get('link');
  }

  ngOnInit(): void {}
  backClicked() {
    this._location.back();
  }
}
